module.exports = __webpack_public_path__ + "img/ИФ-1(А)-010.28902c38.png";